var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterestActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.79449V8.52956C0.5 5.33667 2.76945 2.61335 5.86367 2.08897C7.87168 1.74227 9.99648 2.42104 11.4609 3.91243L12 4.45965L12.4986 3.91243C14.0035 2.42104 16.0879 1.74227 18.1363 2.08897C21.2314 2.61335 23.5 5.33667 23.5 8.52956V8.79449C23.5 10.6901 22.7273 12.5035 21.3617 13.7962L13.2443 21.5021C12.9074 21.8219 12.4627 22 12 22C11.5373 22 11.0926 21.8219 10.7557 21.5021L2.63783 13.7962C1.274 12.5035 0.500013 10.6901 0.500013 8.79449H0.5Z",
    fill: "#FF7B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestActive);
export default __webpack_public_path__ + "static/media/interest_active.0c894b020df9e0849e6935edcb56a4c9.svg";
export { ForwardRef as ReactComponent };